import React, { ReactElement } from 'react';
import { Pill, Text } from '@dotcom/crown-ui';
import { useFeatureFlags } from '../../../hooks';
import { SelectionCardContentProps } from '../contact-types';
import styles from '../contact.module.scss';

export default function SelectionCardContent({
  contact: { first_name, last_name, address_line_1, address_line_2, city, state_code, zip, is_verified },
  topLabel,
  testId,
}: SelectionCardContentProps): ReactElement {
  const { IS_MULT_ADDRESS_ENABLED, IS_INVALID_PILL_ENABLED } = useFeatureFlags();
  return (
    <div className={styles['contact-address-container']} data-testid={testId}>
      {topLabel && (
        <>
          <Text
            as="label"
            className={styles['card-top-label-container']}
            color="textPrimary"
            data-testid="contact-top-label"
            htmlFor=""
            style={{ paddingLeft: 0 }}
          >
            {topLabel}
          </Text>
        </>
      )}
      <Text
        as="label"
        className={styles['card-name-container']}
        htmlFor=""
        color="textPrimary"
        style={{ paddingLeft: 0 }}
      >
        {`${first_name} ${last_name}`}
      </Text>
      {IS_MULT_ADDRESS_ENABLED && IS_INVALID_PILL_ENABLED && !is_verified && (
        <Pill title="USPS invalid" className={styles['pill-element']} />
      )}
      <Text
        as="div"
        className={styles['card-address-line-container']}
        data-testid="contact-address-line"
        color="textPrimary"
      >
        {address_line_1}
        {address_line_2 ? `, ${address_line_2}` : ''}
      </Text>
      <Text
        as="div"
        className={styles['card-address-city-container']}
        color="textPrimary"
        data-testid="contact-city"
      >{`${city}, ${state_code} ${zip}`}</Text>
    </div>
  );
}
